

















import { PartnerPractice } from '@/shared/partner-practice';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PartnerPracticeSelect extends Vue {
    @Inject('$validator') public $validator!: Validator;

    @Prop({ required: true }) private value!: string | null;
    @Prop({ required: true }) private partnerPractices!: Array<PartnerPractice>;
    @Prop({ required: false, default: false }) private all!: boolean;
    @Prop({ required: false, default: false }) private rlgData!: boolean;

    private input: string | null = this.value;

    private get options(): Array<{}> {
        const simpsons = this.partnerPractices
            .filter((partnerPractice) => partnerPractice.isSimpsonsSolicitors)
            .map((partnerPractice) => {
                return {
                    value: partnerPractice.id!,
                    text: partnerPractice.name,
                };
            })
            .sort((a, b) => {
                if (a.text! > b.text!) { return 1; }
                if (a.text! < b.text!) { return -1; }
                return 0;
            });

        simpsons.unshift({ value: '-simpsons-', text: 'All (Simpsons Solicitors)' });

        const partners = this.partnerPractices
            .filter((partnerPractice) => !partnerPractice.isSimpsonsSolicitors)
            .map((partnerPractice) => {
                return {
                    value: partnerPractice.id!,
                    text: partnerPractice.name,
                };
            })
            .sort((a, b) => {
                if (a.text! > b.text!) { return 1; }
                if (a.text! < b.text!) { return -1; }
                return 0;
            });

        partners.unshift({ value: '-partners-', text: 'All (Partner Practices)' });

        const options = [
            { value: null, text: this.all ? 'All' : '--- Please Select ---' },
            { value: '00000000-0000-0000-0000-000000000000', text: 'RLG Data' },
            {
                label: 'Simpsons Solicitors',
                options: simpsons,
            },
            {
                label: 'Partner Practices',
                options: partners,
            },
        ];

        if (!this.rlgData) {
            options.splice(1, 1);
        }

        return options;
    }

    @Watch('value')
    private onValueChanged(value: string | null): void {
        this.input = value;
    }

    @Watch('input')
    private onInputChanged(): void {
        this.$emit('input', this.input);
    }
}
